export interface ApiUser {
  uuid?: string;
  username?: string;
  email?: string;
  display_name?: string;
  first_name?: string;
  last_name?: string;
  groups?: UserGroupNames[];
  is_active?: boolean;
  is_staff?: boolean;
  is_superuser?: boolean;
  is_suspended?: boolean;
  externally_managed?: boolean;
  last_login?: string;
  last_unsuspended?: string;
  modified?: string;
  created?: string;
}

export interface User extends ApiUser {
  xAuthPermissions?: string[];
  xPermissions?: any;
  xGlobalPermissions?: { [key: string]: boolean };
  xEnabledUiFlags?: string[];
  xEnabledFeatures?: string[];
  xProvider?: any;
  xAssignments?: any;
}

export enum UserGroupNames {
  LIMITED_ROOM_ACCESS = 'Limited Room Access',
  LIMITED_SAAS_ACCESS = 'Limited SaaS Access',
  PRIVATE_PRACTICE = 'Private Practice',
  SAAS_PROVIDER = 'SaaS Providers',
  SCHOOL_STAFF_ADMINS = 'School Staff Admins',
  SCHOOL_STAFF_PROCIDERS = 'School Staff Providers',
  TECH_SUPPORT = 'Tech Support',
  SAAS = 'SaaS',
  SERVICE_AND_SUPPORT = 'Service & Support',
  ACCOUNT_MANAGERS = 'Account Managers',
  SAAS_PROVIDERS = 'SaaS Providers',
  ACTIVITY_USERS = 'Activity Users',
  CAPPED_ASSESSMENT_USERS = 'Capped Assessment Users',
  CUSTOMER_ADMIN = 'CustomerAdmin',
}
